function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: "116",
  height: "96"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "fcc656f0-7d47-4c11-8201-68917a8aaf65",
  "data-name": "New Gradient Swatch 5",
  x1: "21.59",
  y1: "11.59",
  x2: "110.41",
  y2: "100.41",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0",
  stopColor: "#35abab"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".67",
  stopColor: "#676e96"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".89",
  stopColor: "#5c568f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#56488b"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "b3e25ce1-2698-43f1-b976-dc1150fdc957",
  x1: "87.06",
  y1: "46.47",
  x2: "108.06",
  y2: "46.47",
  xlinkHref: "#fcc656f0-7d47-4c11-8201-68917a8aaf65"
})), /*#__PURE__*/React.createElement("title", null, "graphic_spot_video-copy"), /*#__PURE__*/React.createElement("g", {
  style: {
    isolation: "isolate"
  }
}, /*#__PURE__*/React.createElement("g", {
  id: "a71a44cf-c316-4e23-8f44-379b5849a339",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M98 0H2a2 2 0 00-2 2v76a2 2 0 002 2h96a2 2 0 002-2V2a2 2 0 00-2-2zM68 5a1 1 0 011-1h10a1 1 0 011 1v6a1 1 0 01-1 1H69a1 1 0 01-1-1zM52 5a1 1 0 011-1h10a1 1 0 011 1v6a1 1 0 01-1 1H53a1 1 0 01-1-1zM36 5a1 1 0 011-1h10a1 1 0 011 1v6a1 1 0 01-1 1H37a1 1 0 01-1-1zM20 5a1 1 0 011-1h10a1 1 0 011 1v6a1 1 0 01-1 1H21a1 1 0 01-1-1zM4 5a1 1 0 011-1h10a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1zm12 70a1 1 0 01-1 1H5a1 1 0 01-1-1v-6a1 1 0 011-1h10a1 1 0 011 1zm16 0a1 1 0 01-1 1H21a1 1 0 01-1-1v-6a1 1 0 011-1h10a1 1 0 011 1zm16 0a1 1 0 01-1 1H37a1 1 0 01-1-1v-6a1 1 0 011-1h10a1 1 0 011 1zm16 0a1 1 0 01-1 1H53a1 1 0 01-1-1v-6a1 1 0 011-1h10a1 1 0 011 1zm16 0a1 1 0 01-1 1H69a1 1 0 01-1-1v-6a1 1 0 011-1h10a1 1 0 011 1zm16 0a1 1 0 01-1 1H85a1 1 0 01-1-1v-6a1 1 0 011-1h10a1 1 0 011 1zm0-64a1 1 0 01-1 1H85a1 1 0 01-1-1V5a1 1 0 011-1h10a1 1 0 011 1z",
  fill: "#7ca5cc",
  opacity: ".3"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    mixBlendMode: "multiply"
  },
  opacity: ".2",
  fill: "#7ca5cc",
  d: "M4 16h92v48H4z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M114 16H18a2 2 0 00-2 2v76a2 2 0 002 2h96a2 2 0 002-2V18a2 2 0 00-2-2zm-30 5a1 1 0 011-1h10a1 1 0 011 1v6a1 1 0 01-1 1H85a1 1 0 01-1-1zm-16 0a1 1 0 011-1h10a1 1 0 011 1v6a1 1 0 01-1 1H69a1 1 0 01-1-1zm-16 0a1 1 0 011-1h10a1 1 0 011 1v6a1 1 0 01-1 1H53a1 1 0 01-1-1zm-16 0a1 1 0 011-1h10a1 1 0 011 1v6a1 1 0 01-1 1H37a1 1 0 01-1-1zm-16 0a1 1 0 011-1h10a1 1 0 011 1v6a1 1 0 01-1 1H21a1 1 0 01-1-1zm12 70a1 1 0 01-1 1H21a1 1 0 01-1-1v-6a1 1 0 011-1h10a1 1 0 011 1zm16 0a1 1 0 01-1 1H37a1 1 0 01-1-1v-6a1 1 0 011-1h10a1 1 0 011 1zm16 0a1 1 0 01-1 1H53a1 1 0 01-1-1v-6a1 1 0 011-1h10a1 1 0 011 1zm16 0a1 1 0 01-1 1H69a1 1 0 01-1-1v-6a1 1 0 011-1h10a1 1 0 011 1zm16 0a1 1 0 01-1 1H85a1 1 0 01-1-1v-6a1 1 0 011-1h10a1 1 0 011 1zm16 0a1 1 0 01-1 1h-10a1 1 0 01-1-1v-6a1 1 0 011-1h10a1 1 0 011 1zm0-64a1 1 0 01-1 1h-10a1 1 0 01-1-1v-6a1 1 0 011-1h10a1 1 0 011 1z",
  fill: "url(#fcc656f0-7d47-4c11-8201-68917a8aaf65)"
}), /*#__PURE__*/React.createElement("rect", {
  x: "20",
  y: "32",
  width: "92",
  height: "48",
  rx: "1",
  style: {
    mixBlendMode: "multiply"
  },
  fill: "#193138",
  opacity: ".2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20 66.76V79a1 1 0 001 1h90a1 1 0 001-1V66.76a22.85 22.85 0 01-6.94 4.24c-18.25 6.92-34.28-15.59-58-15-6.34.13-15.72 2-27.06 10.76z",
  style: {
    mixBlendMode: "multiply"
  },
  opacity: ".1",
  fill: "#193138"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "97.56",
  cy: "46.47",
  r: "10.5",
  style: {
    mixBlendMode: "multiply"
  },
  fill: "url(#b3e25ce1-2698-43f1-b976-dc1150fdc957)",
  opacity: ".2"
})))));